import React, { useState, useRef, useEffect, useContext } from "react";
import { getTableData } from "../../services/summaryReportsService";
import { TableChart } from "../charts/TableChart";
import { MonthNavigator } from "./MonthNavigator";
import { LoadingSpinner } from "../common/LoadingSpinner";
import { CodesToColorMapFunc } from "../../CodesToColorMap";
import { ChartContainerMessage } from "./ChartContainerMessage";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";

export const TableChartContainer = ({ code }) => {
	const [dataSet, setDataSet] = useState([]);

	const [def, setDef] = useState(null);
	const [hasErrored, setHasErrored] = useState(false);

	const { theme } = useContext(DiseaseGroupContext);

	const [cardTheme, setCardTheme] = useState(CodesToColorMapFunc(code, theme));

	let currentDate = dataSet.date ?? null;

	const mounted = useRef(false);

	const getData = (dateToGet) => {
		const then = (responseData) => {
			if (mounted.current === true) {
				currentDate = responseData.data.date;
				setDataSet(responseData.data);
				setDef(responseData.def);
			}
		};

		if (dateToGet === null) {
			getTableData(code)
				.then(then)
				.catch((e) => {
					if (mounted.current === true) {
						setHasErrored(true);
					}
				});
		} else {
			getTableData(code, dateToGet)
				.then(then)
				.catch((e) => {
					if (mounted.current === true) {
						setHasErrored(true);
					}
				});
		}
	};

	useEffect(() => {
		mounted.current = true;
		getData(currentDate);

		return () => {
			mounted.current = false;
		};
	}, []);

	const first = () => {
		if (dataSet.nav.first === currentDate) {
			return;
		}
		getData(dataSet.nav.first);
	};

	const back = () => {
		if (dataSet.nav.prev === null) {
			return;
		}
		getData(dataSet.nav.prev);
	};

	const next = () => {
		if (dataSet.nav.next === null) {
			return;
		}
		getData(dataSet.nav.next);
	};

	const last = () => {
		if (dataSet.nav.last === currentDate) {
			return;
		}
		getData(dataSet.nav.last);
	};

	if (hasErrored === true) {
		return (
			<ChartContainerMessage
				message={[
					"It has not been possible to retrieve your report.",
					"This is most likely because the connection to the internet has been lost.",
					"If this problem persists, please contact our helpdesk, quoting reference '#TC001'.",
				]}
			/>
		);
	}

	if (def === null) {
		return <LoadingSpinner />;
	}

	const totalBox = def.format.hideTotal ? null : (
		<>
			<span>{def.format.totalLabel}</span>{" "}
			<span
				className={`inline-block w-1/4 border border-${def.format.colours.grid} px-1 text-${def.format.colours.text}`}
			>
				<div className={"flex justify-between"}>
					<span className={"block"}>{def.format.unit}</span>{" "}
					<span className={"block"}>{dataSet.total.toFixed(2)}</span>
				</div>
			</span>
		</>
	);

	//const gradient = `${cardTheme.from()} ${cardTheme.via()}`;
	const gradient = "from-white via-white";

	return (
		<div className={"h-full relative"}>
			<MonthNavigator
				heading={dataSet === null ? "Loading" : dataSet.title}
				first={first}
				back={back}
				next={next}
				last={last}
				nav={dataSet ? dataSet.nav : null}
			/>
			<div className={"text-right px-3 pt-3 text-xs xs:text-sm"}>
				{totalBox}
			</div>
			<div className={"h-full relative"}>
				<div>
					<div
						className={
							"absolute top-3 left-0 right-0 bottom-12 px-3 overflow-auto pb-10"
						}
					>
						<TableChart dataSet={dataSet} def={def} />
					</div>
					<div
						className={`block absolute z-20 bottom-10 h-10 px-3 w-full bg-gradient-to-t ${gradient}`}
					>
						{" "}
					</div>
				</div>
			</div>
		</div>
	);
};
